import {
    PlayTypeNameEnum,
    ProgramTypeEnum,
    Territory
} from '@amzn/coral_com-amazon-musicpapercontractconfigurationservice';

import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { IRateCardGridRowData } from 'src/types/IRateCard';
import { getCustomerTypeCamelStr, getProgramTypeCamelStr, getTerritoryCodeById } from 'src/util/grid/cellGetter';
import { getTerritoryFlagRenderer } from 'src/util/grid/cellRenderer';

export const getCppMauColDefs = (territoryMapping: Record<number, Territory>): ColDef[] => [
    {
        field: 'territory',
        headerName: 'Territory',
        filter: 'agSetColumnFilter',
        valueGetter: getTerritoryCodeById(territoryMapping),
        cellRenderer: (params: ICellRendererParams) => getTerritoryFlagRenderer(params, true)
    },
    {
        field: 'rateCardCurrency',
        headerName: 'Rate card currency',
        filter: 'agSetColumnFilter'
    },
    {
        field: 'settlementCurrency',
        headerName: 'Settlement currency',
        filter: 'agSetColumnFilter'
    },
    {
        field: 'cae',
        headerName: 'CAE',
        filter: 'agSetColumnFilter'
    },
    {
        field: 'playType',
        headerName: 'Play type',
        filter: 'agSetColumnFilter',
        hide: true
    },
    {
        field: 'paperPlanName',
        headerName: 'Customer type',
        filter: 'agSetColumnFilter',
        valueGetter: getCustomerTypeCamelStr,
        hide: true
    },
    {
        field: 'programType',
        headerName: 'Program type',
        filter: 'agSetColumnFilter',
        valueGetter: getProgramTypeCamelStr,
        hide: true
    },
    {
        field: 'rate',
        headerName: 'Per play rate'
    }
];

export const showPlayCustomerProgramTypeCols = (
    rowData: IRateCardGridRowData[],
    colDefs: ColDef[],
    isMauGrid = false
) => {
    // Show programType col if not only DEFAULT or empty. Show playType col if not only STANDARD or empty.
    if (rowData.find((row) => ![ProgramTypeEnum.DEFAULT, ''].includes(row.programType))) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        colDefs.find((col) => col.field === 'programType')!.hide = false;
    }
    if (rowData.find((row) => ![PlayTypeNameEnum.STANDARD, ''].includes(row.playType))) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        colDefs.find((col) => col.field === 'playType')!.hide = false;
    }
    // Show customerType/paperPlanName col if it's MAU grid
    if (isMauGrid) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        colDefs.find((col) => col.field === 'paperPlanName')!.hide = false;
    }
};
